import { duration } from '@eturi/date-util'
import {
	benefitGroup$,
	fetchGroupDetails,
	isAuthenticated$,
	isGroupSignUpAllowed$,
	setBenefitGroup,
} from '@op/services'
import { resolveSerial } from '../common'
import { getEndpoints } from '../env'
import {
	landingGroupId$,
	landingPromoTs$,
	landingSSO$,
	resetLandingPromos,
	setSSO,
} from '../reducers/landing.slice'

/**
 * Promos that come in are persisted for at most 2 weeks. They are also cleared on login or
 * sign-up. Thus, if they are unused after 2 weeks, we clear them.
 */
const EFFECTIVE_PROMO_MAX_DURATION =
	process.env.APP_ENV === 'dev' ? duration(3, 'm') : duration(2, 'w')

/** The server enforces SSO be valid for only 10 minutes. */
const SSO_VALIDITY_DURATION = duration(process.env.APP_ENV === 'dev' ? 3 : 10, 'm')

export const landingResolver = resolveSerial(async ({ dispatch, getState }) => {
	let state = getState()

	// Clear SSO state if it's expired
	if ((landingSSO$(state)?.ts ?? Date.now()) < Date.now() - SSO_VALIDITY_DURATION) {
		dispatch(setSSO(null))
	}

	// Clear promo state if it's expired
	if (landingPromoTs$(state) < Date.now() - EFFECTIVE_PROMO_MAX_DURATION) {
		dispatch(resetLandingPromos())
	}

	if (isAuthenticated$(state)) return

	// Get the new state after clearing
	state = getState()

	const [currentBenefitGroup, landingGroupId] = [benefitGroup$(state), landingGroupId$(state)]
	// If we have a group ID, and it's different from our current group, or
	// from we fetch the details

	if (landingGroupId && (!currentBenefitGroup || currentBenefitGroup.group_id !== landingGroupId)) {
		await dispatch(
			fetchGroupDetails({ groupId: landingGroupId, sfsh: getEndpoints()!.sfsh }),
		).unwrap()

		// If it cannot be applied at sign up then we clear the benefits
		if (!isGroupSignUpAllowed$(getState())) dispatch(setBenefitGroup(null))
	}
})
